import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import {handleCaptcha, initCaptcha, resetCaptcha} from '../../utils/captcha';
import {areAllPropertiesEmpty} from "../../utils/helpers";
import {reportJobAlertSubscriptionEvent} from "../../utils/analytics";
import {logErrorMessage} from '../../utils/errors';
import trans from "../../utils/trans";
import showInfoModal from "../../utils/info-modal";
import * as notification from '../../components/notifications';

class AlertSubscriptionForm {
  constructor(section) {
    this.section = section;
    this.alertSubscriptionForm = $(".alert-subscription-form", this.section);
    this.idAttributePrefix = this.section.attr('id') + '-';
    this.captchaId = this.idAttributePrefix + 'captcha-container';

    this._initCaptcha();
    this._initRadiusToggle();
  }

  _initCaptcha() {
    initCaptcha(() => {
      this.alertSubscription();
    }, this.captchaId);

    this.alertSubscriptionForm.submit(handleCaptcha(
      (e) => {
        this.alertSubscription();

        return false;
      }, this.captchaId
    ));
  }

  /**
   * The radius only makes sense together with a location,
   * so it stays disabled until a location is entered.
   */
  _initRadiusToggle() {
    const locationInput = $(`#${this.idAttributePrefix}location`, this.section);
    const radiusSelect = $(`#${this.idAttributePrefix}search_radius`, this.section);

    if (!locationInput.length || !radiusSelect.length) {
      return;
    }

    const toggleRadius = () => {
      const hasLocation = !!String(locationInput.val() || '').trim();

      radiusSelect.prop('disabled', !hasLocation);

      if (typeof radiusSelect.selectpicker === 'function') {
        radiusSelect.selectpicker('refresh');
      }
    };

    locationInput.on('input change', toggleRadius);
    toggleRadius();
  }

  async alertSubscription() {
    const data = this.getAlertSubscriptionData();

    $('.btn-submit', this.alertSubscriptionForm).loading();

    try {
      const response = await axios.post("/api/jobs/subscribe", data);

      resetFormErrors(this.alertSubscriptionForm);

      this.createAlertSubscriptionStatusEvent(response.data.message);

      reportJobAlertSubscriptionEvent();

      this.alertSubscriptionForm.trigger('reset');
      this.alertSubscriptionForm.find('select').selectpicker('refresh');

      $('.btn-submit', this.alertSubscriptionForm).loading(false);
    } catch (e) {
      $('.btn-submit', this.alertSubscriptionForm).loading(false);

      const response = e.response;
      const errors = response && response.data ? response.data.errors : null;

      if (!errors) {
        // Network failure or a response without a validation payload (offline, timeout, 5xx).
        notification.danger('Something went wrong, please reload this page and try again!');
        logErrorMessage('Alert Subscribe: Unexpected error response received', e);
      } else if (typeof errors.message !== 'undefined') {
        notification.danger(errors.message);
      } else {
        response.data.errors = this.mapErrorsToFormInputs(errors);

        if (!Object.keys(response.data.errors).length) {
          response.data.errors.email = ['Something went wrong, please reload this page and try again!'];
          logErrorMessage('Alert Subscribe: Unexpected error response received', e);
        }

        showFormErrors(this.alertSubscriptionForm, response);
      }
    }

    resetCaptcha(this.captchaId);
  }

  /**
   * The API reports field errors with alert_condition.* keys (e.g. alert_condition.location),
   * while the inputs use plain names (location, q, ...). Re-key the errors so they render
   * under their inputs; errors without a matching visible input are dropped.
   */
  mapErrorsToFormInputs(errors) {
    const mappedErrors = {};

    Object.keys(errors).forEach((errorKey) => {
      const inputName = errorKey.indexOf('alert_condition.') === 0
        ? errorKey.substring('alert_condition.'.length).split('.')[0]
        : errorKey;

      if ($(`[name="${inputName}"]`, this.alertSubscriptionForm).length) {
        mappedErrors[inputName] = errors[errorKey];
      }
    });

    return mappedErrors;
  }

  getAlertSubscriptionData() {
    const formData = getFormData(this.alertSubscriptionForm);
    const alertConditions = {};

    if (formData.q) {
      alertConditions.q = formData.q;
    }

    if (formData.category) {
      alertConditions.category = {
        'id': +formData.category
      };
    }

    if (formData.job_type) {
      alertConditions.job_type = {
        'id': +formData.job_type
      };
    }

    if (formData.location) {
      alertConditions.location = formData.location;

      if (formData.location_id) {
        alertConditions.location_id = formData.location_id;
      }

      if (formData.search_radius) {
        alertConditions.search_radius = formData.search_radius;
      }
    }

    if (formData.remote) {
      alertConditions.remote = formData.remote;
    }

    const data = {
      email: formData.email,
      alert_frequency: formData.alert_frequency,
    };

    if (formData['g-recaptcha-response']) {
      data['g-recaptcha-response'] = formData['g-recaptcha-response'];
    }

    if (!areAllPropertiesEmpty(alertConditions)) {
      data.alert_condition = alertConditions;
    }

    return data;
  }

  createAlertSubscriptionStatusEvent(message) {
    const statusBox = $(`<div>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 text-success" viewBox="0 0 16 16">
          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
      </svg>
      ${message}
    </div>`);

    showInfoModal({
      title: trans('alert_subscription.success.title'),
      message: statusBox,
    });
  }
}

const initPage = () => {
  const jbSections = $('.jb-section');

  jbSections.each(function (index) {
    if (!$('.alert-subscription-form-1', this).length) {
      return;
    }

    const sectionContainer = $(this).parent();
    new AlertSubscriptionForm(sectionContainer)
  })
};

$(initPage);
